import { Reducer } from 'redux';
import {
  WebLauncherLandingActionTypes,
  WebLauncherLandingState
} from './types';

export const initialState: WebLauncherLandingState = {};

const reducer: Reducer<WebLauncherLandingState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case WebLauncherLandingActionTypes.GET_WEB_LAUNCHER_SUCCESS:
      return {
        ...state,
        webLaunchRequest: action.payload
      };
    case WebLauncherLandingActionTypes.GET_WEB_LAUNCHER_FAILURE:
      return {
        ...state,
        errorMessage: action.payload
      };
    case WebLauncherLandingActionTypes.CLEAR_WEB_LAUNCHER:
      return initialState;
    default:
      return state;
  }
};

export { reducer as WebLauncherLandingReducer };
